import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from 'api';
import { NotificationsCountType } from '../Notifications.context';

const NOTIFICATIONS_COUNT_QUERY_KEY = 'notifications-count';

type UseNotificationsCountQueryParams = {
  dataRoomId?: string;
  enabled?: boolean;
};

export default function useNotificationsCountQuery({
  dataRoomId,
  enabled = true,
}: UseNotificationsCountQueryParams) {
  const queryClient = useQueryClient();

  const updateNotificationsCount = useCallback(
    (updater: (old: NotificationsCountType) => NotificationsCountType) => {
      queryClient.setQueriesData<NotificationsCountType>(
        { queryKey: [NOTIFICATIONS_COUNT_QUERY_KEY] },
        (oldData) => {
          if (!oldData) return oldData;
          return updater(oldData);
        },
      );
    },
    [queryClient],
  );

  const query = useQuery<NotificationsCountType>({
    queryKey: [
      NOTIFICATIONS_COUNT_QUERY_KEY,
      ...(dataRoomId ? [{ dataRoomId }] : []),
    ],
    queryFn: async () => {
      const { data } = await api.notifications.getUnreadNotifications({
        ...(!!dataRoomId && { dataRoomId }),
      });

      return {
        all: data.allNotificationsCount,
        unread: data.unreadNotificationsCount,
      };
    },
    enabled,
  });

  return { query, updateNotificationsCount };
}
